export const NSI_FRNSI_DICT_LIST = 'nsiFrnsiDictList'
export const NSI_FRNSI_DICTS = 'nsiFrnsiDicts'
export const NSI_FRNSI_DICT_VERSIONS = 'nsiFrnsiDictVersions'
export const NSI_FRNSI_DICTS_RECORDS_LIST = 'msiFrnsiDictsRecordsList'
export const IMPORT_NSI_FRNSI_DICT = 'importNsiFrnsiDict'
